/* eslint-disable no-unused-vars */
export enum NotificationActionTypes {
    UpdateData = 'SET_HEADER_OFFSET_HEIGHT'
}

export type ReducerAction = {
    type: NotificationActionTypes;
    payload?: unknown;
};
